/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  CommitteListService,
  ICommitteListMethods,
  IUpdateMaxInvitesMethods,
  UpdateMaxInvitesService,
  ISingleCommitteMethods,
  SingleCommitteService,
  ICommitteListAnalyticsMethods,
  CommitteListAnalyticsService
} from "./components";

export type CommitteMemberReportPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IUpdateMaxInvitesMethods &
  ISingleCommitteMethods &
  ICommitteListAnalyticsMethods &
  ICommitteListMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new CommitteListService(),
    new UpdateMaxInvitesService(),
    new SingleCommitteService(),
    new CommitteListAnalyticsService()
  ];
};

export const getAgent = () => {
  return createAgent<CommitteMemberReportPageAgent>({
    plugins: getPlugins(),
  });
};
